module.exports = __webpack_public_path__ + "img/p-three-step-04.fd48cbf1.png";